import { useEffect, useRef, useState } from "react";

interface tooltipParagraphProps {
  text: string;
  className?: string;
}

export const TooltipParagraph = ({ text, className} : tooltipParagraphProps) => {
  const paragraphRef = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);
  useEffect(() => {
    if (
      !showTooltip && paragraphRef.current !== null && paragraphRef.current.scrollHeight > paragraphRef.current.offsetHeight
    ) {
      setShowTooltip(true);
    } else {
      setShowTooltip(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paragraphRef, text]);

  return (
    <div className="line-clamp-2" ref={paragraphRef}>
      {showTooltip ? (
        <p 
          data-tooltip-id="tooltip"
          data-tooltip-content={text}  
        >
          {text}
        </p>
      ) : (
        <p>{text}</p>
      )}
    </div>
  )
}